module.exports = __webpack_public_path__ + "static/media/files.88ad44c5.svg";